<script>
    import {url, isActive} from '@roxi/routify';
    let routes = [
        ["./index", "About"],
        ["./base64", "Base64"],
        ["./pwgen", "PWGen"],
        ["./hash", "Hash"],
        ["./colors", "Colors"],

    ];
</script>

<nav class="mnav">
    <ul class="mnav__list">
        {#each routes as [route, label],i}
            <li class="mnav__listitem" class:mnav__listitem--active="{$isActive(route)}"><a href="{$url(route === './index'? '' : route)}">{label}</a></li>
        {/each}
    </ul>
</nav>
